// ** React Imports
import { useMemo } from "react";
import { useParams } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector, useDispatch } from "react-redux";
import { getRankings } from "store/modules/main-pages/rankings/get-ranking.action";

// ** Custom Components
import Block from "components/layout/Block";
import Nav from "components/layout/Nav";
import NavItemLink from "components/base/NavItemLink";

// ** Custom Filters

// ** Custom Hooks
import { compute as filterSexCompute } from "hooks/filters/useFilterSex";
import useFilterPeriod, {
	compute as filterPeriodCompute,
} from "hooks/filters/useFilterPeriod";

// ** Utils & Helpers
import generatePath from "utils/generatePath";
import { ANY } from "helpers/constants";

// ** Context

// #####################################################

const NavPanel = () => {
	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const dispatch = useDispatch();

	const userUrlSearch = useSelector((state) => state.globalUser.urlSearch);
	const userUrlSearchCountry = userUrlSearch
		? userUrlSearch.split("/")[0]
		: null;

	// **
	const userPrefferedSex = useSelector(
		(state) => state.globalUser.searchSex
	).join("-");

	// ** Odczytanie parametrów z adresu URL
	const {
		rankingPeriod: filterPeriodParam = "today",
		country: filterCountryParam = null,
		region: filterRegionParam = null,
		sex: filterSexParam = null,
	} = useParams();

	// ** Hook useFilter - Zakres dat
	const { items: periodItems } = useFilterPeriod({
		initial: {},
	});

	const filterSexFinal = useMemo(() => {
		if (filterSexParam) {
			return filterSexParam;
		} else if (userPrefferedSex === "" || !isAuth) {
			return ""; //"woman-man-couple-transsexual";
		} else if (userPrefferedSex) {
			return userPrefferedSex;
		}
		return ""; //"woman-man-couple-transsexual";
	}, [filterSexParam, userPrefferedSex, isAuth]);

	// #####################################################

	return (
		<Block flex justifyBetween mt={2}>
			<Nav.Panel appearance="tabs" noMargin>
				<Nav.List>
					{periodItems.map((period) => (
						<NavItemLink
							container={Nav.Item}
							to={{
								pathname: generatePath(
									"/rankings/:rankingPeriod/:sex/:country/:region",
									{
										rankingPeriod: period.meta.url,
										country:
											filterCountryParam ||
											userUrlSearchCountry ||
											ANY,
										region: filterRegionParam || ANY,
										sex: filterSexFinal || ANY,
									}
								),
								state: {
									notUseUserSex: false,
									closeFiltersAfterLinkClick: true,
								},
							}}
							key={period.key}
							isActive={() =>
								period.meta.url === filterPeriodParam
							}
							onClick={() => {
								dispatch(
									getRankings({
										apiParams: {
											period: filterPeriodCompute.urlToApiParam(
												period.meta.url
											),
											sex: filterSexCompute(
												true
											).urlToApiParam(filterSexFinal),
											country:
												filterCountryParam ||
												userUrlSearchCountry ||
												ANY,
											region: filterRegionParam || ANY,
										},
										useUrl: true,
									})
								);
							}}
						>
							<Nav.Item.Content>
								{period.content}
							</Nav.Item.Content>
						</NavItemLink>
					))}
				</Nav.List>
			</Nav.Panel>
		</Block>
	);
};

// #####################################################

export default NavPanel;

// #####################################################
